import React, { useEffect, useState } from 'react'
import BuyNFTContainer from '../commons/NFT/BuyNFTContainer'

export default function MarketPlaceList(props) {

  const { data } = props
  const [onSaleItems, setOnSaleItems] = useState([])

  useEffect(() => {
    if (data) {
      setOnSaleItems(data)
    }
  }, [data])

  return (
    <div>
      {
        onSaleItems && onSaleItems.length > 0 ?
          (
            <div className='row'>
              {
                onSaleItems.map((item, index) => (
                  <div key={index} className="d-item col-lg-3 col-md-6 col-sm-6 col-xs-12">
                    <BuyNFTContainer data={item.attributes} objectId={item.id} />
                  </div>

                ))
              }
            </div>
          ) : (
            <div className='row'>
              <div className='col-sm-12 col-md-12 col-lg-12'>
                <div className='loading-container'>
                  Sorry no items available for sale
                </div>
              </div>
            </div>
          )
      }
    </div>
  )
}
